import React from "react";

const TabletIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.76562 11.3806C6.63302 11.3806 6.50584 11.4333 6.41207 11.5271C6.3183 11.6208 6.26562 11.748 6.26562 11.8806C6.26562 12.0132 6.3183 12.1404 6.41207 12.2342C6.50584 12.3279 6.63302 12.3806 6.76562 12.3806H9.76562C9.89823 12.3806 10.0254 12.3279 10.1192 12.2342C10.2129 12.1404 10.2656 12.0132 10.2656 11.8806C10.2656 11.748 10.2129 11.6208 10.1192 11.5271C10.0254 11.4333 9.89823 11.3806 9.76562 11.3806H6.76562ZM3.01562 4.38062C2.5515 4.38062 2.10638 4.56499 1.77819 4.89318C1.45 5.22137 1.26563 5.66649 1.26562 6.13062V12.6306C1.26562 13.5966 2.04962 14.3806 3.01562 14.3806H13.5156C13.9798 14.3806 14.4249 14.1962 14.7531 13.8681C15.0813 13.5399 15.2656 13.0947 15.2656 12.6306V6.13062C15.2656 5.66649 15.0813 5.22137 14.7531 4.89318C14.4249 4.56499 13.9798 4.38062 13.5156 4.38062H3.01562ZM2.26562 6.13062C2.26562 5.9317 2.34464 5.74094 2.48529 5.60029C2.62595 5.45963 2.81671 5.38062 3.01562 5.38062H13.5156C13.7145 5.38062 13.9053 5.45963 14.046 5.60029C14.1866 5.74094 14.2656 5.9317 14.2656 6.13062V12.6306C14.2656 12.8295 14.1866 13.0203 14.046 13.1609C13.9053 13.3016 13.7145 13.3806 13.5156 13.3806H3.01562C2.81671 13.3806 2.62595 13.3016 2.48529 13.1609C2.34464 13.0203 2.26562 12.8295 2.26562 12.6306V6.13062Z"
      fill="white"
    />
  </svg>
);

export default TabletIcon;
